import React from 'react';
import { Grid, Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { AgentInputType } from '../../../../types/AgentInputType.types';
import DebounceTextField from '../../../../components/DebounceTextfield';
import { AgentStatus } from '../../../../types/Agent.types';
import Agentv2 from '../../../../types/Agentv2.types';
import AgentProjects from '../../../../components/AgentEdit/AgentProjects';
import PanelCard from './PanelCard';

interface SystemsPanelProps {
  agentId?: string;
  isExistingActive: boolean;
}

function SystemsPanel({ agentId, isExistingActive }: SystemsPanelProps) {
  const { values, handleChange, errors, handleBlur, initialValues } = useFormikContext<AgentInputType | Agentv2>();

  return (
    <Box>
      <PanelCard title="myJACK & CentralNode" subtitle="Zugangsdaten und Synchronisations-Status">
        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} sm={6}>
            <DebounceTextField
              type="text"
              label="myJACK Login"
              name="myjack_login"
              aria-label="myjack_login"
              value={values.myjack_login || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={
                (initialValues.status_id === AgentStatus.active && initialValues.myjack_login !== null) ||
                initialValues.status_id === AgentStatus.dismissed ||
                values.status_id === AgentStatus.failed
              }
              helperText={errors.myjack_login}
              error={Boolean(errors.myjack_login) || false}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <DebounceTextField
              type="number"
              label="myJACK Unit"
              name="jackplus_id"
              aria-label="jackplus_id"
              value={values.jackplus_id || ''}
              onChange={handleChange}
              onBlur={handleBlur}
              disabled={
                initialValues.status_id === AgentStatus.active ||
                initialValues.status_id === AgentStatus.dismissed ||
                values.status_id === AgentStatus.failed
              }
              helperText={errors.jackplus_id}
              error={Boolean(errors.jackplus_id) || false}
              fullWidth
            />
          </Grid>
        </Grid>

        {isExistingActive && agentId && (
          <AgentProjects id={values.id || ''} agentId={values.agent_id || ''} contractId={values.contract_type_id} />
        )}
      </PanelCard>
    </Box>
  );
}

export default SystemsPanel;
